import { ApiSlugs, ListPagination, UserForAdminDto, UserId, UserSummaryDto } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

// Don't use ApiEntityStateConnector, user are handled very specifically
export class UsersAdminConnector extends ApiConnector<UserForAdminDto, UserForAdminDto, UserId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.USERS);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<UserSummaryDto[]> =>
      this.apiCaller.getRequest<UserSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
